import React, { useEffect, useState } from 'react';
import API from '../services/api';
import { useLanguage } from '../context/LanguageContext';
import PageHeader from '../components/PageHeader';
import Modal from '../components/Modal';
import { FormField, Input, Select, Textarea, SubmitBtn } from '../components/FormField';
import './Announcements.css';

export default function Announcements() {
  const { t, lang } = useLanguage();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({title:'',content:'',target_role:'all'});
  const [saving, setSaving] = useState(false);

  const load = () => { setLoading(true); API.get('/announcements').then(r=>{setItems(r.data); setLoading(false);}); };
  useEffect(()=>{ load(); }, []);

  const handleSave = async e => {
    e.preventDefault(); setSaving(true);
    try {
      if (modal === 'add') await API.post('/announcements', form);
      else await API.put('/announcements/'+form.id, form);
      setModal(null); load();
    } finally { setSaving(false); }
  };

  const ROLES = {
    all: t('announcements.roleAll'),
    student: t('announcements.roleStudent'),
    teacher: t('announcements.roleTeacher'),
    parent: t('announcements.roleParent'),
  };
  const locale = lang === 'en' ? 'en-US' : 'az-AZ';

  return (
    <div>
      <PageHeader icon="announcements" title={t('announcements.title')} subtitle={`${t('common.total')} ${items.length} ${t('announcements.countSuffix')}`}
        action={<button className="btn btn-primary" onClick={()=>{setForm({title:'',content:'',target_role:'all'}); setModal('add');}}>{t('announcements.btnAdd')}</button>} />
      {loading ? <div style={{textAlign:'center',padding:'60px',color:'#888'}}>{t('common.loading')}</div> : (
        <div className="ann-grid">
          {items.length === 0 && <div style={{textAlign:'center',color:'#aaa',padding:'60px',background:'white',borderRadius:12}}>{t('announcements.empty')}</div>}
          {items.map(item => (
            <div key={item.id} className="ann-card">
              <div className="ann-card-header">
                <span className={'ann-role ann-'+item.target_role}>{ROLES[item.target_role]||item.target_role}</span>
                <div style={{display:'flex',gap:6}}>
                  <button className="btn btn-sm btn-secondary" onClick={()=>{setForm(item); setModal('edit');}}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                    {t('announcements.btnEdit')}
                  </button>
                  <button className="btn btn-sm btn-danger" onClick={async()=>{if(window.confirm(t('common.confirmDelete'))){await API.delete('/announcements/'+item.id); load();}}}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3,6 5,6 21,6"/><path d="M19 6l-2 14a2 2 0 01-2 2H9a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
                    {t('announcements.btnDelete')}
                  </button>
                </div>
              </div>
              <h3 className="ann-card-title">{item.title}</h3>
              <p className="ann-card-content">{item.content}</p>
              <div className="ann-card-footer">
                <span>{item.author_name}</span>
                <span>{new Date(item.created_at).toLocaleDateString(locale)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
      {modal && (
        <Modal title={modal==='add'?t('announcements.modalNew'):t('announcements.modalEdit')} onClose={()=>setModal(null)}>
          <form onSubmit={handleSave}>
            <FormField label={t('announcements.fieldTitle')} required><Input value={form.title} onChange={e=>setForm(p=>({...p,title:e.target.value}))} required /></FormField>
            <FormField label={t('announcements.fieldText')}><Textarea value={form.content} onChange={e=>setForm(p=>({...p,content:e.target.value}))} /></FormField>
            <FormField label={t('announcements.fieldTarget')}>
              <Select value={form.target_role} onChange={e=>setForm(p=>({...p,target_role:e.target.value}))}>
                <option value="all">{t('announcements.targetAll')}</option>
                <option value="student">{t('announcements.targetStudents')}</option>
                <option value="teacher">{t('announcements.targetTeachers')}</option>
                <option value="parent">{t('announcements.targetParents')}</option>
              </Select>
            </FormField>
            <div className="form-actions">
              <button type="button" className="btn btn-secondary" onClick={()=>setModal(null)}>{t('common.cancel')}</button>
              <SubmitBtn loading={saving}>{modal==='add'?t('common.add'):t('common.save')}</SubmitBtn>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}
